export default "__VITE_ASSET__DUJPVJOW__"